import { Container, Title, Text, Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container style={{ textAlign: 'center', marginTop: '5rem' }}>
      <Title order={1}>404</Title>
      <Text size="lg" mb="md">
        Page not found
      </Text>
      <Button onClick={() => navigate('/')}>Go Home</Button>
    </Container>
  );
}

export default NotFoundPage;
